import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@hqo/react-components-library/dist/molecules/modals/modal';
import { ModalProps } from './modal.interface';
import { mediaMaxWidth } from '@hqo/react-components-library/dist/device';

const modalVariants: Record<NonNullable<ModalProps['variant']>, ReturnType<typeof css>> = {
  small: css`
    min-height: 300px;
  `,
  normal: css`
    padding: 32px;
    min-height: 348px;
  `,
  wide: css`
    min-height: 348px;
  `,
};

export const StyledModal = styled(Modal)<{ variant: NonNullable<ModalProps['variant']> }>`
  overflow: auto;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 348px;
    max-height: 683px;
    max-width: 963px;
    padding: 24px 32px;
    margin: auto;
    overflow: initial;
    height: fit-content;

    ${({ variant }) => modalVariants[variant]}

    ${mediaMaxWidth(css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      padding: 16px;
      overflow-y: auto;
    `)}
  }
`;

export const StyledMobileModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.universal.white};

  overflow-y: auto;
`;

export const CloseButton = styled(FontAwesomeIcon)`
  position: absolute;
  top: 17px;
  right: 17px;

  color: ${({ theme }): string => theme.colors.fontColor};
`;
